<template>
  <div class="home">
     <div class="relative max-w-5xl mx-auto">
      <div class="flex flex-col min-h-screen lg:flex-row lg:items-center lg:p-8">
        <div class="flex flex-col flex-grow bg-white lg:shadow-2xl lg:rounded-lg lg:overflow-hidden">
          <div class="flex-grow flex flex-col justify-center p-12">
            <div class="flex items-center">              
              <svg width="220px" viewBox="0 0 200 50" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
                <g>
                    <g id="G1" serif:id=" [IDML]" transform="matrix(1.26433,0,2.33553e-33,1.26433,-64.4218,-434.586)">
                        <path d="M52.636,363.585C52.636,352.711 61.451,343.896 72.325,343.896C83.199,343.896 92.014,352.711 92.014,363.585C92.014,369.756 89.175,375.264 84.731,378.874L79.281,354.328L65.37,354.328L59.919,378.874C55.476,375.264 52.636,369.756 52.636,363.585Z" style="fill:rgb(238,118,36);fill-rule:nonzero;"></path>
                    </g>
                    <g id="G2" serif:id=" [IDML]" transform="matrix(1.26433,0,2.33553e-33,1.26433,-64.4218,-434.586)">
                        <path d="M84.053,379.402C80.777,381.834 76.719,383.274 72.325,383.274C67.931,383.274 63.874,381.834 60.598,379.402C64.974,367.7 68.386,359.537 70.738,356.696C71.118,356.237 71.683,355.946 72.325,355.946C72.967,355.946 73.541,356.238 73.922,356.696C76.273,359.537 79.677,367.7 84.053,379.402Z" style="fill:rgb(238,118,36);fill-rule:nonzero;"></path>
                    </g>
                </g>
                <g transform="matrix(0.3997,0,7.38344e-34,0.3997,84.0725,25.0542)">
                    <path d="M0,0.001C0,-12.719 -5.094,-19.168 -15.142,-19.168C-25.331,-19.168 -30.283,-12.898 -30.283,0.001C-30.283,12.9 -25.331,19.169 -15.142,19.169C-5.094,19.169 0,12.72 0,0.001M-7.846,0.001C-7.846,9.239 -10.233,13.73 -15.142,13.73C-20.05,13.73 -22.437,9.239 -22.437,0.001C-22.437,-9.237 -20.05,-13.728 -15.142,-13.728C-10.233,-13.728 -7.846,-9.237 -7.846,0.001" style="fill:rgb(35,31,32);fill-rule:nonzero;"></path>
                </g>
                <g transform="matrix(0.3997,0,7.38344e-34,0.3997,65.3734,17.3929)">
                    <path d="M0,38.337C-10.135,38.337 -15.717,31.474 -15.717,19.011C-15.717,6.751 -10.47,0 -0.942,0C4.909,0 11.742,2.883 11.742,11.009L11.742,11.559L3.843,11.559L3.843,11.009C3.843,8.256 3.274,5.44 -0.942,5.44C-6.669,5.44 -7.871,12.309 -7.871,18.071C-7.871,27.73 -4.834,32.425 1.412,32.425C5.109,32.425 8.231,30.605 9.406,29.92L10.382,29.356L10.382,36.06L10.047,36.201C8.168,36.999 4.363,38.337 0,38.337" style="fill:rgb(35,31,32);fill-rule:nonzero;"></path>
                </g>
                <g transform="matrix(0.3997,0,7.38344e-34,0.3997,105.964,17.623)">
                    <path d="M0,37.187L-7.219,37.187L-7.219,5.754L-16.268,5.754L-16.268,0L9.048,0L9.048,5.754L0,5.754L0,37.187Z" style="fill:rgb(35,31,32);fill-rule:nonzero;"></path>
                </g>
                <g transform="matrix(0.3997,0,7.38344e-34,0.3997,99.1483,17.623)">
                    <path d="M0,37.187L-12.666,0L-20.827,0L-33.546,37.187L-25.994,37.187L-22.855,27.406L-10.689,27.406L-7.551,37.187L0,37.187ZM-12.5,21.652L-21.045,21.652L-16.772,8.026L-12.5,21.652Z" style="fill:rgb(35,31,32);fill-rule:nonzero;"></path>
                </g>
                <g transform="matrix(0.3997,0,7.38344e-34,0.3997,119.866,17.8401)">
                    <path d="M0,36.871L4.435,36.871L16.725,0L13.519,0L2.298,33.665L2.191,33.665L-8.817,0L-12.023,0L0,36.871Z" style="fill:rgb(147,149,152);fill-rule:nonzero;"></path>
                </g>
                <g transform="matrix(0.3997,0,7.38344e-34,0.3997,125.851,17.8401)">
                    <path d="M0,36.871L3.153,36.871L6.893,24.955L20.68,24.955L24.58,36.871L27.733,36.871L15.817,0L11.702,0L0,36.871ZM13.466,2.619L13.573,2.619L19.771,22.016L7.855,22.016L13.466,2.619Z" style="fill:rgb(147,149,152);fill-rule:nonzero;"></path>
                </g>
                <g transform="matrix(0.3997,0,7.38344e-34,0.3997,139.529,17.8401)">
                    <path d="M0,36.871L16.298,36.871L16.298,33.932L3.206,33.932L3.206,0L0,0L0,36.871Z" style="fill:rgb(147,149,152);fill-rule:nonzero;"></path>
                </g>
                <g transform="matrix(0.3997,0,7.38344e-34,0.3997,148.36,17.8401)">
                    <path d="M0,36.871L16.832,36.871L16.832,33.932L3.206,33.932L3.206,19.024L15.763,19.024L15.763,16.085L3.206,16.085L3.206,2.939L16.404,2.939L16.404,0L0,0L0,36.871Z" style="fill:rgb(147,149,152);fill-rule:nonzero;"></path>
                </g>
                <g transform="matrix(0.3997,0,7.38344e-34,0.3997,158.365,17.8401)">
                    <path d="M0,36.871L3.206,36.871L3.206,4.756L3.313,4.756L18.702,36.871L23.298,36.871L23.298,0L20.092,0L20.092,32.97L19.985,32.97L4.328,0L0,0L0,36.871Z" style="fill:rgb(147,149,152);fill-rule:nonzero;"></path>
                </g>
                <g transform="matrix(0.3997,0,7.38344e-34,0.3997,180.266,19.9977)">
                    <path d="M0,26.076C-1.229,26.984 -3.687,29.015 -8.924,29.015C-17.687,29.015 -19.29,19.023 -19.29,12.343C-19.29,4.595 -17.046,-2.94 -9.779,-2.94C-4.061,-2.94 -2.244,1.122 -2.244,4.648L1.389,4.648C1.389,1.389 0.535,-1.069 -1.496,-2.94C-3.313,-4.703 -6.092,-5.985 -9.404,-5.985C-19.931,-5.985 -22.817,3.312 -22.817,12.076C-22.817,22.549 -19.45,32.061 -9.137,32.061C-3.954,32.061 -1.389,30.458 0,29.817L0,26.076Z" style="fill:rgb(147,149,152);fill-rule:nonzero;"></path>
                </g>
                <g transform="matrix(0.3997,0,7.38344e-34,0.3997,-12.2402,-19.9941)">
                    <rect x="489.93" y="94.656" width="3.206" height="36.871" style="fill:rgb(147,149,152);"></rect>
                </g>
                <g transform="matrix(0.3997,0,7.38344e-34,0.3997,187.522,17.8401)">
                    <path d="M0,36.871L3.153,36.871L6.893,24.955L20.68,24.955L24.58,36.871L27.733,36.871L15.817,0L11.703,0L0,36.871ZM13.466,2.619L13.573,2.619L19.771,22.016L7.855,22.016L13.466,2.619Z" style="fill:rgb(147,149,152);fill-rule:nonzero;"></path>
                </g>
              </svg>
            </div>
            <div class="md:pl-16 pl-0">
              <h1 class="sm:font-light text-2xl sm:text-3xl md:text-4xl text-gray-900 mt-6">Verificador de documentos telemáticos</h1>
              <div v-if="mostrarFormulario">
                <p class="sm:text-xl text-gray-600 mt-3 leading-relaxed">COAT Valencia pone a su disposición este servicio que le permite verificar la validez de cualquier documento técnico (proyecto, certificado, etc.) en el que aparece el sello de la intervención colegial.
                <br />Para ello únicamente deberá introducir el Código seguro de verificación (CSV) que figura en el sello y comprobar que los datos que se muestran coinciden con los de su documento.</p>
                <div class="py-6">
                  <input class="shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" v-model="codigo" type="text" placeholder="Código CSV">
                  <button @click="verificar" class="ml-6 bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white py-2 px-4 border border-blue-500 hover:border-transparent rounded"> verificar</button>
                </div>
              </div>
            </div>
          </div>
          <div class="bg-gray-100 border-t-2 border-gray-200" v-if="mostrarDatos">
            <div class="flex flex-wrap">
              <div class="flex flex-col px-12 py-10 w-full sm:border-r sm:border-b border-gray-300">
                <div class="flex flex-grow">
                  <div>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-8 w-8 md:h-10 md:w-10 md:-my-1">
                      <path class="fill-current text-gray-400" d="M3 6l9 4v12l-9-4V6zm14-3v2c0 1.1-2.24 2-5 2s-5-.9-5-2V3c0 1.1 2.24 2 5 2s5-.9 5-2z" />
                      <polygon class="fill-current text-gray-700" points="21 6 12 10 12 22 21 18" />
                    </svg>
                  </div>
                  <div class="leading-relaxed flex flex-col ml-4 md:ml-6">
                    <h2 class="font-medium text-gray-800 text-lg">Datos identificativos de la intervención profesional</h2>
                    <p class="text-gray-600 mt-1 text-sm md:text-base">Número</p>
                    <p class="text-teal-600 mt-0 text-sm md:text-base">{{ validacion.NumeroVisado }}</p>
                    <p class="text-gray-600 mt-1 text-sm md:text-base">Tipo de intervención</p>
                    <p class="text-teal-600 mt-0 text-sm md:text-base">{{ validacion.Objeto }}</p>
                    <p class="text-gray-600 mt-3 text-sm md:text-base">Descripción</p>
                    <p class="text-teal-600 mt-0 text-sm md:text-base">{{ validacion.Descripcion }}</p>
                    <p class="text-gray-600 mt-3 text-sm md:text-base">Emplazamiento</p>
                    <p class="text-teal-600 mt-0 text-sm md:text-base">{{ validacion.Emplazamiento }}</p>
                    <p class="text-gray-600 mt-3 text-sm md:text-base">Promotor</p>
                    <p class="text-teal-600 mt-0 text-sm md:text-base">{{ validacion.Promotores }}</p>
                    <p v-if="descarga" class="text-gray-600 mt-3 text-sm md:text-base">Técnicos autores</p>
                    <p v-if="descarga" class="text-teal-600 mt-0 text-sm md:text-base">{{ validacion.Tecnicos }}</p>
                  </div>
                </div>
              </div>
              <div class="flex flex-col px-12 py-6 w-full sm:border-r sm:border-b border-gray-300">
                <div class="flex flex-grow">
                  <div>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-8 w-8 md:h-10 md:w-10 md:-my-1">
                      <path class="fill-current text-gray-400" d="M3 6l9 4v12l-9-4V6zm14-3v2c0 1.1-2.24 2-5 2s-5-.9-5-2V3c0 1.1 2.24 2 5 2s5-.9 5-2z" />
                      <polygon class="fill-current text-gray-700" points="21 6 12 10 12 22 21 18" />
                    </svg>
                  </div>
                  <div class="leading-relaxed flex flex-col ml-4 md:ml-6">
                    <h2 class="font-medium text-gray-800 text-lg">Datos identificativos del documento</h2>
                    <p class="text-gray-600 mt-1 text-sm md:text-base">Descripción</p>
                    <p class="text-teal-600 mt-0 text-sm md:text-base">{{ validacion.DescripcionDocumento }}</p>                    
                    <p v-if="descarga == false" class="text-gray-600 mt-3 text-sm md:text-base">Técnicos autores</p>
                    <p v-if="descarga == false" class="text-teal-600 mt-0 text-sm md:text-base">{{ validacion.Tecnicos }}</p>
                  </div>
                </div>
              </div>
              <div class="flex flex-col px-12 py-6 w-full sm:border-r sm:border-b border-gray-200">
                <div class="flex flex-grow">
                  <div>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-8 w-8 md:h-10 md:w-10 md:-my-1">
                      <path class="fill-current text-gray-400" d="M3 6l9 4v12l-9-4V6zm14-3v2c0 1.1-2.24 2-5 2s-5-.9-5-2V3c0 1.1 2.24 2 5 2s5-.9 5-2z" />
                      <polygon class="fill-current text-gray-700" points="21 6 12 10 12 22 21 18" />
                    </svg>
                  </div>
                  <div class="leading-relaxed flex flex-col ml-4 md:ml-6">
                    <h2 class="font-medium text-gray-800 text-lg">Intervención colegial realizada</h2>
                    <p class="text-teal-600 mt-1 text-sm md:text-base">{{ fechaTramite }}</p>
                    <p class="text-teal-600 mt-1 text-sm md:text-base">{{ validacion.TipoTramite }}</p>
                    <p class="text-teal-600 mt-1 text-sm md:text-base">{{ validacion.VisadoGarantia }}</p>
                  </div>
                </div>
              </div>
              <div v-if="descarga" class="flex flex-col px-12 py-6 w-full sm:border-r sm:border-b border-gray-200">
                <div class="flex flex-grow">
                  <div>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-8 w-8 md:h-10 md:w-10 md:-my-1">
                      <path class="fill-current text-gray-400" d="M3 6l9 4v12l-9-4V6zm14-3v2c0 1.1-2.24 2-5 2s-5-.9-5-2V3c0 1.1 2.24 2 5 2s5-.9 5-2z" />
                      <polygon class="fill-current text-gray-700" points="21 6 12 10 12 22 21 18" />
                    </svg>
                  </div>
                  <div class="leading-relaxed flex flex-col ml-4 md:ml-6">
                    <h2 class="font-medium text-gray-800 text-lg">Fichero PDF</h2>
                    <a :href="urlFichero"> Descargar</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="bg-gray-100 border-t-2 border-gray-200" v-if="error">
            <div class="flex flex-wrap">
              <div class="flex flex-col px-12 py-10 w-full sm:border-r sm:border-b border-gray-300">
                <div class="flex flex-grow">
                  <div>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-8 w-8 md:h-10 md:w-10 md:-my-1">
                      <path class="fill-current text-gray-400" d="M3 6l9 4v12l-9-4V6zm14-3v2c0 1.1-2.24 2-5 2s-5-.9-5-2V3c0 1.1 2.24 2 5 2s5-.9 5-2z" />
                      <polygon class="fill-current text-gray-700" points="21 6 12 10 12 22 21 18" />
                    </svg>
                  </div>
                  <div class="leading-relaxed flex flex-col ml-4 md:ml-6">
                    <h2 class="font-medium text-red-800 text-lg">Error!</h2>
                    <p class="text-red-600 mt-0 text-sm md:text-base">El código introducido no es válido</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="bg-gray-100 border-t-2 border-gray-200" v-if="anulado">
            <div class="flex flex-wrap">
              <div class="flex flex-col px-12 py-10 w-full sm:border-r sm:border-b border-gray-300">
                <div class="flex flex-grow">
                  <div>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-8 w-8 md:h-10 md:w-10 md:-my-1">
                      <path class="fill-current text-gray-400" d="M3 6l9 4v12l-9-4V6zm14-3v2c0 1.1-2.24 2-5 2s-5-.9-5-2V3c0 1.1 2.24 2 5 2s5-.9 5-2z" />
                      <polygon class="fill-current text-gray-700" points="21 6 12 10 12 22 21 18" />
                    </svg>
                  </div>
                  <div class="leading-relaxed flex flex-col ml-4 md:ml-6">
                    <h2 class="font-medium text-red-800 text-lg">Nota</h2>
                    <p class="text-red-600 mt-0 text-sm md:text-base">Este documento ha sido anulado y existe una nueva versión actualizada del mismo. Para más información debe contactar con el profesional que suscribe el documento.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="error || anulado || validacion != null" class="flex flex-col px-12 py-6 w-full sm:border-r sm:border-b border-gray-200">
            <div class="flex flex-grow">
              <button @click="nuevaVerificacion" class="bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white py-2 px-4 border border-blue-500 hover:border-transparent rounded"> verificar otro documento</button>
            </div>
          </div>
          <div class="bg-gray-300 border-t-2 border-gray-200">
            <div class="flex flex-wrap">
              <div class="flex flex-col px-12 py-10 w-full sm:border-r sm:border-b border-gray-300">
                <div class="flex flex-grow">
                   <p class="text-center w-full">© 2020 - Colegio Oficial de la Arquitectura Técnica de Valencia</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import validacionTelematicaService from '../services/validacionTelematicaService.js';
import Vue from "vue";
import { VueReCaptcha } from "vue-recaptcha-v3";
Vue.use(VueReCaptcha, { siteKey: "6LdJP_cUAAAAAPz7cQIf2LIYJp91kTko-Y9JaHVr" });

export default {
  name: 'Home',
  data () {
    return {
      validacion: null,
      codigo: '', // Anulado -> 286AE5C80910  Descarga -> EC08B1938BEB  Texto garantia -> FAE7676D9554
      error: false,
      descarga: false,
      anulado: false,
    }
  },
  created() {
    this.loadFromApi()
  },
  computed: {
    fechaTramite() {
        var info = this.validacion.FechaTramite.substr(0,10).split('-').reverse().join('/');
        return info;
   },
   urlFichero() {
    return 'http://api.caatvalencia.es/api/ValidacionTelematica?codigo=' + this.codigo + '&file='+ this.codigo +'.pdf'
   },
   mostrarDatos() {
     return !this.anulado && this.validacion != null;
   },
   mostrarFormulario() {
     return this.validacion == null && !this.error && !this.anulado 
   }

  },
  methods: {
    loadFromApi() {
     
    },
    verificar() {
      this.error = false
      this.$recaptcha("contactus").then(token => {
        validacionTelematicaService.get(this.codigo)
          .then((validacion) => {
              this.validacion = validacion.data;
              this.anulado = this.validacion.FechaAnulacion != null;
              this.descarga = this.validacion.DescargaIntegra
              if(this.anulado)
                this.validacion = null;
            }
          )
          .catch((error) => {
          // Error 😨
          this.validacion = null
          this.error = true
          if (error.response) {
              /*
              * The request was made and the server responded with a
              * status code that falls out of the range of 2xx
              */
              console.log(error.response.data);
              console.log(error.response.status);
              console.log(error.response.headers);
          } else if (error.request) {
              /*
              * The request was made but no response was received, `error.request`
              * is an instance of XMLHttpRequest in the browser and an instance
              * of http.ClientRequest in Node.js
              */
              console.log(error.request);
          } else {
              // Something happened in setting up the request and triggered an Error
              console.log('Error', error.message);
          }
          });
      
        console.log(token);
      });
    },
    nuevaVerificacion() {
      this.codigo = ""
      this.validacion = null
      this.error = false
      this.anulado = false
    }
  }
 
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  padding: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.pendiente {
  color: #ff0000;
}
</style>
